export enum HeaderType {
  USER = 'user',
  NON_USER = 'non-user',
}
